const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`aff71e37b671ba3936f36ce3d5a6afe256398a07e1a35036ef3cc93efb61b0d1`, `aff71e37b671ba3936f36ce3d5a6afe256398a07e1a35036ef3cc93efb61b0d1`, 1, 62), new Map([[`class`, `o-container--prose o-container--pad`]]), false, false, 1));
            }

            getTemplateName() {
                return `aff71e37b671ba3936f36ce3d5a6afe256398a07e1a35036ef3cc93efb61b0d1`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `aff71e37b671ba3936f36ce3d5a6afe256398a07e1a35036ef3cc93efb61b0d1`, ``);
            }
        }],
        [62, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/container/container.twig`, `aff71e37b671ba3936f36ce3d5a6afe256398a07e1a35036ef3cc93efb61b0d1`, 1);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/container/container.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    `);
                this.echo(this.include(context, this.source, this.loadTemplate(`aff71e37b671ba3936f36ce3d5a6afe256398a07e1a35036ef3cc93efb61b0d1`, `aff71e37b671ba3936f36ce3d5a6afe256398a07e1a35036ef3cc93efb61b0d1`, 5, 61), undefined, false, false, 5));
                this.echo(`  `);
            }

            getTemplateName() {
                return `aff71e37b671ba3936f36ce3d5a6afe256398a07e1a35036ef3cc93efb61b0d1`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `aff71e37b671ba3936f36ce3d5a6afe256398a07e1a35036ef3cc93efb61b0d1`, ``);
            }
        }],
        [61, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/rhythm/rhythm.twig`, `aff71e37b671ba3936f36ce3d5a6afe256398a07e1a35036ef3cc93efb61b0d1`, 5);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/rhythm/rhythm.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`        <p>This card simply fills the content element:</p>
        `);
                this.echo(this.include(context, this.source, this.loadTemplate(`aff71e37b671ba3936f36ce3d5a6afe256398a07e1a35036ef3cc93efb61b0d1`, `aff71e37b671ba3936f36ce3d5a6afe256398a07e1a35036ef3cc93efb61b0d1`, 8, 57), new Map([[`class`, `c-card--contained`]]), false, false, 8));
                this.echo(`        <p>This card gains the default container padding:</p>
        `);
                this.echo(this.include(context, this.source, this.loadTemplate(`aff71e37b671ba3936f36ce3d5a6afe256398a07e1a35036ef3cc93efb61b0d1`, `aff71e37b671ba3936f36ce3d5a6afe256398a07e1a35036ef3cc93efb61b0d1`, 16, 58), new Map([[`class`, `c-card--contained o-container__pad`]]), false, false, 16));
                this.echo(`        <p>This card attempts to fill the container, padding included:</p>
        `);
                this.echo(this.include(context, this.source, this.loadTemplate(`aff71e37b671ba3936f36ce3d5a6afe256398a07e1a35036ef3cc93efb61b0d1`, `aff71e37b671ba3936f36ce3d5a6afe256398a07e1a35036ef3cc93efb61b0d1`, 24, 59), new Map([[`class`, `c-card--contained o-container__fill`]]), false, false, 24));
                this.echo(`        <p>This card fills the container and applies padding to align its content with adjacent elements:</p>
        `);
                this.echo(this.include(context, this.source, this.loadTemplate(`aff71e37b671ba3936f36ce3d5a6afe256398a07e1a35036ef3cc93efb61b0d1`, `aff71e37b671ba3936f36ce3d5a6afe256398a07e1a35036ef3cc93efb61b0d1`, 32, 60), new Map([[`class`, `c-card--contained o-container__fill-pad`]]), false, false, 32));
                this.echo(`      `);
            }

            getTemplateName() {
                return `aff71e37b671ba3936f36ce3d5a6afe256398a07e1a35036ef3cc93efb61b0d1`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `aff71e37b671ba3936f36ce3d5a6afe256398a07e1a35036ef3cc93efb61b0d1`, ``);
            }
        }],
        [57, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/card/card.twig`, `aff71e37b671ba3936f36ce3d5a6afe256398a07e1a35036ef3cc93efb61b0d1`, 8);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/card/card.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`            <p>.c-card.c-card--contained</p>
          `);
            }

            getTemplateName() {
                return `aff71e37b671ba3936f36ce3d5a6afe256398a07e1a35036ef3cc93efb61b0d1`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `aff71e37b671ba3936f36ce3d5a6afe256398a07e1a35036ef3cc93efb61b0d1`, ``);
            }
        }],
        [58, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/card/card.twig`, `aff71e37b671ba3936f36ce3d5a6afe256398a07e1a35036ef3cc93efb61b0d1`, 16);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/card/card.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`            <p>.c-card.c-card--contained.o-container__pad</p>
          `);
            }

            getTemplateName() {
                return `aff71e37b671ba3936f36ce3d5a6afe256398a07e1a35036ef3cc93efb61b0d1`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `aff71e37b671ba3936f36ce3d5a6afe256398a07e1a35036ef3cc93efb61b0d1`, ``);
            }
        }],
        [59, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/card/card.twig`, `aff71e37b671ba3936f36ce3d5a6afe256398a07e1a35036ef3cc93efb61b0d1`, 24);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/card/card.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`            <p>.c-card.c-card--contained.o-container__fill</p>
          `);
            }

            getTemplateName() {
                return `aff71e37b671ba3936f36ce3d5a6afe256398a07e1a35036ef3cc93efb61b0d1`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `aff71e37b671ba3936f36ce3d5a6afe256398a07e1a35036ef3cc93efb61b0d1`, ``);
            }
        }],
        [60, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/card/card.twig`, `aff71e37b671ba3936f36ce3d5a6afe256398a07e1a35036ef3cc93efb61b0d1`, 32);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/card/card.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`            <p>.c-card.c-card--contained.o-container__fill-pad</p>
          `);
            }

            getTemplateName() {
                return `aff71e37b671ba3936f36ce3d5a6afe256398a07e1a35036ef3cc93efb61b0d1`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `aff71e37b671ba3936f36ce3d5a6afe256398a07e1a35036ef3cc93efb61b0d1`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'aff71e37b671ba3936f36ce3d5a6afe256398a07e1a35036ef3cc93efb61b0d1');

let template = env.loadTemplate('aff71e37b671ba3936f36ce3d5a6afe256398a07e1a35036ef3cc93efb61b0d1');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/objects/container/demo/fill.twig", args: context }
     );
     return rendered;;
};